import Amenities from './Amenities';

export default Amenities;
